import React, { useEffect, useState } from 'react';

import styled from '@emotion/styled';

import Stars from '../../../components/Badge/Stars';
import StatusCell from '../../../components/Badge/StatusCell';
import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import MoreInfoIcon from '../../../components/Icons/MoreInfoIcon';
import PageLayout from '../../../components/Layout/PageLayout';
import Page from '../../../components/Page/Page';
import Table from '../../../components/Table/Table';
import ViewDetails from '../../../components/Table/TableAccessories/ViewDetails';
import DriverPerformanceProfileView from '../../../components/Table/TableSliderViews/DriverPerformanceProfileView';
import {
  PERFORMANCE_MONITORING,
  PERFORMANCE_MONITORING_VIEW_PERFORMANCE,
} from '../../../routes/routeConstants';

const PerformanceMonitoringViewPerformance = () => {
  const [pathArr, setPathArr] = useState<Record<string, string>[]>([]);

  useEffect(() => {
    setPathArr(() => [
      {
        name: `Performance Monitoring`,
        link: `/${PERFORMANCE_MONITORING}`,
      },
      {
        name: `Driver Performance List`,
        link: `/${PERFORMANCE_MONITORING_VIEW_PERFORMANCE}`,
      },
    ]);
    // eslint-disable-next-line
  }, []);

  return (
    <Page title='Logirate | Performance Monitoring View Performance'>
      <PageLayout>
        <BreadCrumbs pathData={pathArr as any} />
        <Container>
          <Table
            // border
            tableTitle='DRIVER LIST'
            tableFilterBoxFeatures={{
              showSearchBox: true,
              searchBoxPlaceholder: 'Search',
            }}
            tableHeader={{
              'Driver Name': 'driverName',
              'Time at Company': 'timeAtCompany',
              'Driver Rating': 'driverRating',
              'Status with Company': 'statusWithCompany',
            }}
            tableDataSourceUrl='authentication-service/ba/v1/company/users/warehouse'
            cellsCustomComp={{
              driverRating: <Stars dataKey='driverRating' />,
              statusWithCompany: (
                <StatusCell statusKey='statusWithCompany' hasDot />
              ),
            }}
            moreOptionsComponents={[
              <ViewDetails
                key='view-details'
                label='View Details'
                width='232px'
                icon={<MoreInfoIcon />}
                sliderCompFn={(data: any) => (
                  <DriverPerformanceProfileView data={data} />
                )}
              />,
            ]}
            // mobileCellComp={<UserProfileManagementCell />}
            // showPaginationControl={false}
          />
        </Container>
      </PageLayout>
    </Page>
  );
};

export default PerformanceMonitoringViewPerformance;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
